import { useLoaderData } from 'react-router-dom';
import FilterMenu from '../components/streetview/filterMenu';
import StreetviewMap from '../components/streetview/map';
import {
  FilterCategory,
} from '../types/filters.type';
import GetAllFilters from '../services/adapters/allFilters';
import PostMapClient from '../services/adapters/mapClient';
import { MapClient } from '../types/global';
import { useFilterModal } from '../components/modalProvider';
import { FilterModalType } from '../types/enums';
import useAllFilterStore from '../shared/hooks/allFilterStore';

export async function loader() {
  const filterAdapter = new GetAllFilters();
  const filters = filterAdapter.adaptResponse();

  const mapClientAdapter = new PostMapClient();
  const mapClient = mapClientAdapter.adaptResponse();

  const [filterData,mapClientData] = await Promise.all([filters, mapClient]);
  useAllFilterStore.getState().setFilterTypeLookup(filterData);
  return [filterData, mapClientData];
}

export default function StreetView() {
  const data = useLoaderData<[ filters: FilterCategory[], mapClient: MapClient ]>();
  const [filters, mapClient] = data;
  const { openFilterModal, closeModal } = useFilterModal();

  const showAdvancedFilterModal = () => {
    openFilterModal({
      mode: FilterModalType.Advanced,
      isOpen: true,
      onClose: closeModal,
    });
  };

  return (
    <div className="flex flex-col w-full h-screen overflow-auto lg:flex-row">
      <StreetviewMap mapConfig={mapClient} />
      <FilterMenu filters={filters} onShowModal={showAdvancedFilterModal} />
    </div>
  );
}
